<template>
<div>


        <h2 v-if="showTitle !== false">烽行体育用户协议</h2>

    <h3>特别声明：</h3>

    <div class="c">烽行体育是一款有关竞彩、足彩、篮彩等体育赛事彩票精准推荐的网站、APP产品，专注提供竞彩、足彩、篮彩等体育赛事资讯推荐（以下简称“我们”或“甲方”）。在此特别提醒用户（以下简称“您”或“乙方”），本网站、APP是一款推荐类产品，不提供彩票投注服务。在使用本网站平台上提供的推荐服务前仔细阅读《用户协议》（下称“本协议”）中的各个条款，包括但不限于描述本网站责任的条款、对用户权利描述的条款以及约定争议解决方式和管辖的条款。</div>

    <div class="c">本协议已对与您的权益有或可能具有重大关系的条款，及对我们具有或可能具有免责或限制责任的条款用粗体字予以标注，请您注意。如您对本协议的任何条款表示异议，您可以选择不进入烽行体育，
        如您同意本协议的全部条款，请按照注册页面上的提示完成全部的注册程序。您在进行注册过程中点击“提交注册”按钮即表示您愿意接受本协议项下的全部条款，并明确了解所有条款的内容和法律后果，
        请您在进行注册时注意此步骤并选择接受或者不接受本协议，您一旦选择访问或使用烽行体育平台上提供的服务，将视为同意接受本协议全部条款的约束。</div>

    <div class="c">除非另有明确确定，烽行体育所推出的新产品、新功能和新服务，均无条件地适用本协议。</div>

    <div class="c">烽行体育保留在任何时候修改本协议条款的权利，本协议一旦发生变动，我们将会在相关的页面上提示以让用户及时获得更新的协议内容，修改后的服务协议一旦在页面上公布且您接受即有效，便代替原来的协议，您可随时访问本页面查阅最新服务协议。如您不同意本服务协议及或我们对其的修改，请停止使用我们提供的服务，否则您既不接受也不停止使用我们的服务，即视同您同意并完全接受修订后的协议版本。</div>

    <div class="c">用户无论通过何种方式使用烽行体育提供的服务，均受本协议约束。</div>

    <div class="c">您与我们达成的本协议所列明的条款，并不能完全涵盖您与我们所有的权利和义务。因此，烽行体育平台发布的相关政策、相关活动及声明、规定构成本协议的补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力，您须同时遵守。</div>

    <div class="c">
        <h4>1、注册账号</h4>

        <div class="sj">1.1  乙方承诺以其真实身份注册成为甲方的用户，应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。</div>

        <div class="sj">1.2  如乙方提供给甲方的资料不准确，不真实，不合法有效，甲方保留随时结束乙方使用甲方各项服务的权利。乙方同意，其提供的真实、准确的本网站注册资料作为认定乙方与其本网站帐号的关联性以及用户身份的唯一证据。甲方提醒乙方，用户注册账号或更新注册信息时填写的证件号码，在注册账号成功或补充填写后将无法进行修改，请乙方慎重填写各类注册信息。</div>
    </div>


    <div class="c">
        <h4>2、用户账号使用与保管</h4>

        <div class="sj">2.1  甲方有权审查乙方注册所提供的身份信息是否真实、有效，并应积极地采取适当措施保障用户账号的安全、有效；乙方有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方因过错导致账号密码遗失、账号被盗等情形而给对方和他人的民事权利造成损害的，应当承担由此产生的法律责任，但第三方恶意侵犯或者其他不可抗力的除外。</div>

        <div class="sj">2.2   乙方对登录后所持账号产生的行为后果依法享有权利和承担责任。</div>

        <div class="sj">2.3   乙方发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据甲方公布的处理方式通知甲方，通知甲方采取措施暂停该账号的登录和使用。</div>

        <div class="sj">2.4   甲方根据乙方的通知采取措施暂停乙方账号的登录和使用的，甲方应当要求乙方提供并核实与其注册身份信息相一致的个人有效身份信息。</div>

        <div class="st">2.4.1   甲方核实乙方所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停乙方账号的登录和使用。</div>

        <div class="st">2.4.2   甲方违反2.4.1款项的约定，未及时采取措施暂停乙方账号的登录和使用，因此而给乙方造成损失的，应当承担其相应的法律责任。</div>

        <div class="st">2.4.3   乙方没有提供其个人有效身份证件或者乙方提供的个人有效身份证件与所注册的身份信息不一致的，甲方有权拒绝乙方上述请求并不承担全部责任。</div>

        <div class="sj">2.5   乙方为了维护其合法权益，向甲方提供与所注册的身份信息相一致的个人有效身份信息时，甲方应当为乙方提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。</div>

        <div class="sj">2.6   乙方在参与“烽行擂台”时，会向所有烽行体育用户展示包括但不限于账号头像、名称、用户说明等注册信息及认证资料，以及其他使用账号或本服务所产生的内容。不得违反国家相关法律制度，包含但不限于如下原则：</div>

        <div class="st">（1）  反对宪法所确定的基本原则的；</div>
        <div class="st">（2）  危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</div>
        <div class="st">（3）  损害国家荣誉和利益的；</div>
        <div class="st">（4）  煽动民族仇恨、民族歧视，破坏民族团结的；</div>
        <div class="st">（5）  破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
        <div class="st">（6）  散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
        <div class="st">（7）  散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
        <div class="st">（8）  侮辱或者诽谤他人，侵害他人合法权益的；</div>
        <div class="st">（9）  含有法律、行政法规禁止的其他内容的。</div>

        <div class="sj">2.7   乙方不得利用烽行体育的账号名称及头像制作、上载、复制、发布、传播干扰本网站正常运营，以及侵犯其他用户或第  三方合法权益的内容：</div>

        <div class="st">（1）  含有任何性或性暗示的；</div>
        <div class="st">（2）  含有辱骂、恐吓、威胁内容的；</div>
        <div class="st">（3）  含有骚扰、垃圾广告、恶意信息、诱骗信息的；</div>
        <div class="st">（4）  涉及他人隐私、个人信息或资料的；</div>
        <div class="st">（5）  侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</div>
        <div class="st">（6）  含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。</div>

    </div>

    <div class="c">
        <h4>3、服务的中止与终止</h4>
        <div class="sj">3.1  乙方在接受甲方服务时实施不正当行为的，甲方有权终止对乙方提供服务并不承担法律责任。该不正当行为的具体情形应当在本协议中有明确约定或属于甲方事先明确告知的应被终止服务的禁止性行为，否则，甲方不得终止对乙方提供服务。</div>
        <div class="sj">3.2  乙方提供虚假注册身份信息，或实施违反本协议的行为，甲方有权中止对乙方提供全部或部分服务并不承担责任。甲方根据本条约定中止或终止对乙方提供部分或全部服务的，甲方应负举证责任。</div>
        <div class="sj">3.3  乙方有通过在烽行体育平台的注册身份将购买的推荐产品进行线下交易的行为，一经查出甲方将给予乙方封号处理，并有权取消乙方的用户资格而无须给予任何补偿，并不予退还乙方在本平台账户的所剩余额。</div>
    </div>

    <div class="c">
        <h4>4、用户信息保护</h4>

        <div class="sj">4.1  甲方要求乙方提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向乙方公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护乙方的个人信息资料的安全。</div>

        <div class="sj">4.2  未经乙方许可甲方不得向任何第三方提供、公开或共享乙方注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：</div>

        <div class="st">4.2.1  乙方或乙方监护人授权甲方披露的；</div>

        <div class="st">4.2.2  有关法律要求甲方披露的；</div>

        <div class="st">4.2.3  司法机关或行政机关基于法定程序要求甲方提供的；</div>

        <div class="st">4.2.4  甲方为了维护自己合法权益而向乙方提起诉讼或者仲裁时；</div>

        <div class="st">4.2.5  其他法律法规规定应当提供乙方个人身份信息时。</div>

        <div class="sj">4.3  乙方理解并同意，在不透露单个用户隐私资料的前提下，甲方有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。甲方尽管对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。</div>
    </div>


    <div class="c">
        <h4>5、知识产权及所有权声明</h4>
        <div class="sj">5.1  我们所提供的产品和服务仅供个人注册用户使用。与产品和服务有关的全部信息、资料、技术（包括相关的APP软件）的著作权、专利权、商标、商业秘密、其他知识产权、所有权或其他权利，均为我们或其权利人所有，除非事先获得我们或其权利人的合法书面授权，您不得对任何该信息、资料、软件、产品和服务进行修改、拷贝、散布、传送、展示、执行、复制、发行、授权、制作衍生产品、移转或销售。如果您违反以上规定，我们可立即终止向您提供产品和服务并向您追究法律责任，您必须销毁任何您获得的上述信息、资料、软件或产品。</div>
        <div class="sj">5.2  烽行体育中所提供的全部赛事推荐属于我们所提供的产品，其中用户所充值的“FXB”不可提现。本网站里的推荐产品其所有权归我们所有，用户只能在遵守法律和本协议规定及充值规定的情况下使用。我们不认可通过本网站平台用户的线下交易所产生的交易结果，我们有权对该交易行为涉及的所有关注赛事采取相应的措施，包括但不限于：冻结账户余额、对账号进行封停账号等处理；情节严重的，我们保留追究用户法律责任的权利。</div>
    </div>


    <div class="c">
        <h4>6、用户守则：为了营造公平、正常、稳定、良好的软件使用环境，您在使用我们提供的产品和服务时应该遵守以下守则：</h4>
        <div class="sj">6.1  妥善保管在注册服务时获得的账号（注册成功后不可变更）及密码，谨防泄露或被盗，并为此账号及密码登入系统后的行为或活动负责。请不要将账号、密码转让或出借给他人使用，如因您的保管疏忽或其他任何个人行为导致您的账号或密码遭他人非法使用及因此所产生的任何后果，我们不承担任何责任。若您发现账号或密码遭他人非法使用或有异常使用的情形，应立即通知我们，并提交该账号为您本人所有的有关证明，以便申请该账号的暂停使用。</div>
        <div class="sj">6.2  遵守所有服务的网络协议、规定和程序，并遵守我们针对其各种服务制定的相应服务条款。您不得进行任何侵犯我们或产品权利人知识产权的行为，或者进行其他有损我们或其他用户合法权益的行为，包括但不限于：</div>
        <div class="st">（1）  攻击、侵入我们的网站服务器或使网站服务器过载；</div>
        <div class="st">（2）  进行编译、反编译、反向工程或其他任何方式破解、修改我们提供的产品或服务；</div>
        <div class="st">（3）  攻击、侵入我们的产品服务器或产品服务器端程序或使产品服务器过载；</div>
        <div class="st">（4）  制作、发布、传播任何形式的妨碍产品公平性的辅助工具或程序或其他的作弊软件；</div>
        <div class="st">（5）  利用程序的漏洞和错误（Bug）破坏产品的正常进行，获得不正当的非法利益，或利用互联网或其他方式传播该漏洞或错误（Bug）；</div>
        <div class="st">（6）  利用我们所提供的产品和服务从事任何诸如发布广告、销售商品的商业行为，或者进行任何非法的侵害我们利益的行为；</div>
        <div class="st">（7）  发表、转发、传播含有谩骂、诅咒、诋毁、攻击、诽谤光烽行体育或第三方内容的，或者含有封建迷信、淫秽、色情、下流、恐怖、暴力、凶杀、赌博、反动、煽动民族仇恨、危害祖国统一、颠覆国家政权等让人反感、厌恶的内容的非法言论；</div>
        <div class="st">（8）  进行恶意刷屏、恶意耗时、利用产品软件或系统的不完善恶意影响其他用户使用等恶意破坏产品公共秩序的行为；</div>
        <div class="st">（9）  利用我们提供的产品或服务故意传播恶意程序或计算机病毒，或者发表、转发、传播侵犯第三方知识产权、肖像权、姓名权、名誉权、隐私或其他合法权益的文字、图片、照片、程序、视频、图像或动画等资料，发布假冒官方网站网址或链接。</div>
        <div class="st">（10） 不合理地干扰或阻碍他人使用我们所提供的产品和服务。</div>
        <div class="st">（11） 其他损害我们和其他用户权益的行为。如您的行为给我们造成损害的，您应承担赔偿责任。</div>
        <div class="sj">6.3  如发现产品漏洞时须及时、主动向产品管理人员汇报，我们对举报者有奖。</div>
    </div>


    <div class="c">
        <h4>7、资费政策</h4>
        <p>我们有权决定我们所提供的产品和服务的资费标准和收费方式，我们可能会就不同的产品和服务制定不同的资费标准和收费方式，也可能按照我们所提供的产品和服务的不同阶段确定不同的资费标准和收费方式。另外，根据阶段性的经营策略以及外部因素等，我们也可能不时地修改我们的资费政策或发布产品促销活动。我们会将有关产品和服务的收费信息以及与该产品和服务有关的资费标准、收费方式、购买方式、产品活动说明或其他有关资费政策的信息放置在该产品和服务相关网页的显著位置，只有您根据提示确认支付，则表示您已全部接受我们的资费政策并同意遵守我们的产品活动规则，我们保留对资费政策及产品促销活动的一切解释和修改权利。对于我们的收费产品和服务，您应该按照我们确定的资费政策购买我们的产品和服务。如果您未按我们确定的资费政策购买我们的产品和服务，我们可以立即停止向您提供该产品和服务。</p>

        <div class="sj">7.1  关于增值服务，指按照烽行体育的指定方式支付一定服务费用之后，用户可以享有由本网站或第三方提供的在本网站产品特权的服务。</div>

        <p>烽行体育可能会根据不同的产品及服务类型，推出不同的增值服务，目前，本网站提供欧亚指数、超级计算机、专家指数不同种类的增值服务，同时，本网站也可能会根据用户的需求、产品及服务类型的变化等，对现有增值服务种类进行调整以及不断推出新的增值服务种类。本网站也可能会在不同时间推出具体不同的服务内容，以不断完善、优化本服务。具体增值服务种类及服务内容以相关服务页面公布、实际提供的内容为准。您可以自行根据需要选择相应服务。</p>

        <div class="sj">7.2  关于收费，烽行体育可能会根据本服务的整体规划，对本服务的收费标准、方式等进行修改和变更，前述修改、变更，本网站将在相应服务页面进行展示。您若需要获取、使用该产品，请先提前了解清楚当时关于该产品的收费标准、方式等信息。</div>

        <div class="sj">7.3  服务的变更、中止或终止，您充分了解并同意，由于互联网服务的特殊性，烽行体育可能会按照相关法规、双方约定或基于其他必要原因时，暂时或永久中止或终止向您提供服务之全部或部分，而无须提前通知。届时，本网站会依法保护您的合法权益，但除此之外，对您和任意第三人均无需承担任何责任。</div>
    </div>

    <div class="c">
        <h4>8.免责声明</h4>

        <div class="sj">8.1  我们提供的产品和服务可能会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于：</div>

        <div class="st">（1）  其他用户可能会发布诈骗或虚假信息，或者发表含有谩骂、诅咒、诋毁、攻击内容的，或含有淫秽、色情、下流、发动、煽动民族仇恨等让人反感、厌恶的内容的非法言论；</div>
        <div class="st">（2）  其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私或其他合法权益的图片、照片、文字等资料；</div>
        <div class="st">（3）  面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。对于上述困扰，我们将尽可能地采取相应措施维护您的合法权益。</div>

        <div class="sj">8.2  您充分理解并同意：上述第8.1条款所述的各种不良信息、网络安全和网络故障问题，并不是我们所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，我们无须向您承担任何责任。</div>
        <div class="sj">8.3  您充分理解并同意：用户从事本协议第6.2条所述的第（1）—（5）项行为，是一种即时性的瞬间消失的行为，且会严重影响我们的产品和服务，因此，我们一经分析判断确认用户从事了该等行为，
            我们可能会立即采取诸如本协议第5.2 条所述的处理措施，对此，您是充分给予理解。</div>

        <div class="sj">8.4  您充分理解并同意：用户从本协议第6.2条所述的第（6）—（9）项行为，是一种即时性的瞬间即可让众多用户知晓的行为。如果不立即采取诸如本协议第5.2条所述的处理措施，可能会造成非常严重非常恶劣的后果。对此，您是给予充分理解的，并完全同意我们采取上述措施对上述行为进行处理。</div>

        <div class="sj">8.5  您充分理解并同意：为了有效遏制用户使用BUG或外挂的行为，我们可能会采取停机维护或者回档的处理措施。停机维护期间，您可能会不能登陆烽行体育服务器。对此，您充分理解并愿意自行承担，我们将不给予任何赔偿。</div>

        <div class="sj">8.6  您充分理解并同意：我们的产品或服务可能会因为我们或者我们合作方的互联网系统软硬件设备的故障、失灵、或人为操作的疏失而全部或一部分中断、暂时无法使用、迟延，或因他人侵入系统篡改或伪造变造资料等，
            造成服务的停止或中断者或用户档案缺失，以及因相关政府机构要求的停止或中断，我们无须给以您或第三方任何的补偿或赔偿。</div>

        <div class="sj">8.7  您充分理解并同意：“烽行擂台”赛中的榜单中，会展示包含但不限于账号头像、名称等。</div>

        <div class="sj">8.8  您同意使用我们的产品或服务是出于您个人意愿，并愿自行承担任何风险及由此给您造成的任何直接、间接、衍生的损害，我们不承担任何责任。若依法无法完全排除损害赔偿责任时，我们的赔偿责任亦以返还您就实施该等使用行为而支付给我们的价款为限。</div>

        <div class="sj">8.9  烽行体育所有推荐皆由本网站合作签订的专家发布，本网站仅提供技术上的支持，对推荐的内容的正确性、完整性及品质不承担责任。因此：本站所有内容仅作为用户参考，不代表本站观点，更不表示我们支持用户使用，请您认真考虑后使用，因为使用不当所造成的损失我们不承担任何法律后果。对于经由烽行体育服务而传送的内容，本网站不保证您在接受有关服务时，有可能因专家发布的信息内容，有可能接触到令人不快、不适当或令人讨厌的内容。在任何情况下，本网站均不对任何内容负责。</div>

        <div class="sj">8.10 烽行体育网站、APP可能刊登商业广告或其他活动促销的广告。这些内容系广告商或商品服务提供者所为，我们仅提供刊登内容的媒介。您通过我们或我们所链接的网站所购买的服务或商品，其交易行为仅存于您与该商品或服务的提供者之间，与本网站无关。</div>

        <div class="sj">8.11 您可能在使用我们的产品和服务过程中链接到第三方的站点。第三方的站点不由我们控制，并且我们也不对任何第三方站点的内容、第三方站点包含的任何链接、或第三方站点的任何更改或更新负责。我们仅为了提供便利的目的而向您提供这些到第三方站点的链接，我们所提供的这些链接并不意味着我们认可该第三方站点。您需要检查并遵守该第三方站点的相关规定。</div>

        <div class="sj">8.12 您同意我们保留随时地、不事先通知地、不需要任何理由地、单方面地中止履行本协议及终止本协议的权利，您不会因此认为我们违反合同约定并承担法律责任。该等中止、终止，可能是因为服务公司解散、注销、合并、分立，也可能是因为国家法律、法规、政策及国家机关的命令或者其他的诸如地震、火灾、海啸、台风、罢工、战争等不可抗力事件，还可能是上列原因之外的其他原因。</div>

        <div class="sj">8.13 您充分理解到：已购的烽行体育产品（包含会员服务、结果为胜的预测产品）不予退还。</div>

    </div>


    <div class="c">
        <h4>9.其他约定</h4>

        <div class="sj">9.1  本协议各条款是可分的，所约定的任何条款如果部分或者全部无效，不影响该条款其他部分及本协议其他条款的法律效力。</div>

        <div class="sj">9.2  本协议各条款的标题只是为了方便用户阅读而起到提示、醒目的作用，对本协议的解释及适用没有任何指引作用。</div>

        <div class="sj">9.3  烽行体育网站、APP为“烽行体育”，您如对本协议条款有任何疑问或者需要帮助，可以通过上述电话与我们联系。</div>

        <div class="sj">9.4  本协议及其补充协议的订立、执行和解释及争议的解决均应适用法律。</div>

        <div class="sj">9.5  如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向烽行体育网站、APP产品所属公司所在地的人民法院提起诉讼。</div>

        <div class="sj">9.6  本条款最终解释权归烽行体育所有。</div>

    </div>


    <template v-if="showTitle === false">
    <div class="c s">【审慎提醒】如您点击“我已同意”，则本协议将立即生效，并构成与本网站及其经营的“烽行体育”之间具有约束力的法律文件。</div>
    <div class="c s">请您确认您已全部阅读本协议并充分理解本协议之全部条款。</div>
    </template>

</div>
</template>

<script>
    export default {
        name: "fxtreaty",
        props:  ['showTitle'],
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
